var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53 53",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #323a45;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 52.84,
    height: 53,
    rx: 3.02
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.78,17.46A1.49,1.49,0,0,1,21.26,16H42.19c0-.89,0-1.65-.09-2.26a30.9,30.9,0,0,0-7-3.92,30.47,30.47,0,0,0-5.82-1.66,16.28,16.28,0,0,0-5.57,0,30.47,30.47,0,0,0-5.82,1.66,30.9,30.9,0,0,0-7,3.92,32.6,32.6,0,0,0-.06,3.86,35.19,35.19,0,0,0,5.85,17.86A34.15,34.15,0,0,0,26.47,45a34.13,34.13,0,0,0,9.84-9.56,35.09,35.09,0,0,0,4.5-9.68H21.26a1.49,1.49,0,0,1,0-3H41.54a34.15,34.15,0,0,0,.54-3.84H21.26A1.48,1.48,0,0,1,19.78,17.46Zm1.48,12.13H32a1.49,1.49,0,0,1,0,3H21.26a1.49,1.49,0,0,1,0-3Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo.a78c095ec48d3437f43474f5045019df.svg";